import { getAuth } from 'firebase/auth'
import { UserProfileFragmentFragmentDoc } from '../../../graphql/generated'
import cache from '../../../providers/apollo/cache'

export default function useProfilePlan() {
  const userId = getAuth().currentUser?.uid ?? ''
  const profile = cache.readFragment({ fragment: UserProfileFragmentFragmentDoc, fragmentName: 'UserProfileFragment', id: `UserProfile:${userId}` })
  const plan = profile?.plan ?? { plan_name: 'No plan' }
  const billingInterval = plan.billing_interval ?? 'Never'

  const bucketLimit = Number(plan.bucket_limit ?? 3)
  const isStoragePlan = plan.is_storage_plan === true
  const isSharingPlan = plan.is_sharing_plan === true
  const isSharingEnabled = plan.is_sharing_enabled
  const isNoPlan = plan.plan_name === 'no-plan'
  const isFreemiumUser = plan.plan_name === 'freemium'
  const canCreateBucket = plan.is_create_bucket_enabled === true

  return { isSharingPlan, isStoragePlan, billingInterval, isNoPlan, canCreateBucket, isSharingEnabled, isFreemiumUser, bucketLimit }
}
